import type { RootState } from '../../../index';

export const chatOpenSelector = (state: RootState) => state.chat.isOpen;
export const chatRoomSelector = (state: RootState) => state.chat.room;
export const chatBanSelector = (state: RootState) => state.chat.isBanned;
export const chatIdSelector = (state: RootState) => state.chat.id;
export const chatIsOnlineSelector = (state: RootState) => state.chat.isOnline;
export const chatIsMaintenanceSelector = (state: RootState) => state.chat.isMaintenance;

export const chatAgentSelector = (state: RootState) =>
  state.chat.connectedSupports[state.chat.connectedSupports.length - 1];

export const chatOnceStartedSelector = (state: RootState) => state.chat.onceStarted;

export const chatPopupSelector = (state: RootState) => state.chat.popup;
